import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	content: {
		paddingBottom: theme.spacing(4),
		cursor: 'grab'
	},
	header: {
		paddingLeft: theme.spacing(1)
	},
	schematicSkeleton: {
		margin: theme.spacing(1)
	},
	focusableIconButton: {
		'&:focus': {
			boxShadow: ''
		}
	}
}));
